import { ApiMethodDeclaration } from 'retail-front-services/api';

import { RegisterTransferRequest, RegisterTransferResponse } from '@utils/types';

type Request = {
    cardData: RegisterTransferRequest;
    publicId: string;
};

/**
 * Создаёт операцию перевода
 */
export const registerTransfer: ApiMethodDeclaration<Request, RegisterTransferResponse> = ({ cardData, publicId }) => ({
    url: `/transfer/register?publicId=${publicId}`,
    method: 'POST',
    data: cardData
});
